import React from 'react';
import { createTableElementClassName } from './tableStyles';

type Props = {
  id?: string;
  active?: boolean;
  disabled?: boolean;
  secondary?: boolean;
  blinking?: boolean;
  onClick?(): void;
};

export const TableTr: React.FC<Props> = (props) => {
  const {
    id,
    children,
    active,
    disabled,
    secondary,
    blinking,
    onClick,
  } = props;

  const className = createTableElementClassName('row', {
    active,
    disabled,
    secondary,
    blinking,
  });

  return (
    <tr id={id} className={className} onClick={disabled ? undefined : onClick}>
      {children}
    </tr>
  );
};
